import { type AddHookResponse, mutationAdd } from '../hooks'
import { useTantalimMutation } from '../mutation'
import {
  toResponseError,
  type ProgramCloneInput,
  type ProgramCloneSuccess,
  type ProgramData,
} from '@terros/common'
import { useProgramCache } from './cache'

export function useCloneProgram(): AddHookResponse<ProgramCloneInput, ProgramData> {
  const mutation = useTantalimMutation<ProgramCloneInput, ProgramCloneSuccess>({
    url: '/program/clone',
  })
  const cache = useProgramCache()

  async function add(input: ProgramCloneInput): Promise<ProgramData> {
    try {
      const { program } = await mutation.mutateAsync(input)
      cache.clearList()
      return program
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
